import { baseUrlAssets as assets } from "lib/actions/endpoints/endpoints";
import { Endpoint } from "lib/types/Endpoint";

export const endpointsAssets = {
  asset: (id: number): string => `${assets}/${id}`,
  deletionRestriction: (id: number) => `${assets}/${id}/delete-restriction`,
  delete: (id: number): Endpoint => ({
    method: "DELETE",
    url: endpointsAssets.asset(id),
  }),
  update: (id: number): Endpoint => ({
    method: "PATCH",
    url: endpointsAssets.asset(id),
  }),
  publishDraft: (id: number): Endpoint => ({
    method: "POST",
    url: `${assets}/${id}/publishdraft`,
  }),
  projectAssets: (projectId: number): string =>
    `${assets}/projects/${projectId}`,
  projectTrustedGeometry: (projectId: number): string =>
    `${assets}/projects/${projectId}/geometry/trusted`,
  projectUntrustedGeometry: (projectId: number): string =>
    `${assets}/projects/${projectId}/geometry/untrusted`,
  projectCdn: (projectId: number) => `${assets}/projects/${projectId}/cdn`,
  projectAssetElementPropertiesFacets: (
    projectId: number,
    filterMinCount?: number,
    filterReferences?: string[],
  ): string => {
    const params = new URLSearchParams();
    if (filterMinCount != null) {
      params.set("filterMinCount", String(filterMinCount));
    }
    if (filterReferences?.length) {
      filterReferences.forEach((ref) => params.append("filterReferences", ref));
    }
    const query = params.toString();
    let url = `${assets}/projects/${projectId}/assets-properties/facets`;
    if (query) url += `?${query}`;
    return url;
  },
  projectDataUsage: (projectId: number) =>
    `${assets}/storage/project/${projectId}`,
  projectIngresses: (id: number) => `${assets}/projects/${id}/ingresses`,
  ingressDismiss: (id: number) => ({
    method: "PUT",
    url: `${assets}/ingresses/${id}/dismiss`,
  }),
  versionProperties: (id: number, elementId: string): Endpoint => ({
    // AutoCAD layer group ids contain '#', which would otherwise end the path.
    url: `${assets}/versions/${id}/elements/${encodeURIComponent(elementId)}/properties`,
    method: "GET",
  }),
  versionSource: (id: number): Endpoint => ({
    method: "GET",
    url: `${assets}/versions/${id}/source`,
  }),
  versionDownloadUrl: (id: number): Endpoint => ({
    method: "GET",
    url: `${assets}/versions/${id}/download-url`,
  }),
  versionDeletionRestriction: (id: number) =>
    `${assets}/versions/${id}/delete-restriction`,
  versionDelete: (versionId: number): Endpoint => ({
    method: "DELETE",
    url: `${assets}/versions/${versionId}`,
  }),
  versionRevertTo: (id: number): Endpoint => ({
    method: "POST",
    url: `${assets}/versions/${id}/revert`,
  }),
  versionPromote: (id: number): Endpoint => ({
    method: "POST",
    url: `${assets}/versions/${id}/promote`,
  }),
  versionSetPositionCorrect: (id: number): Endpoint => ({
    method: "PUT",
    url: `${assets}/versions/${id}/positioncorrect`,
  }),
  attachments: (id: number) => `${assets}/${id}/attached`,
  attach: (id: number): Endpoint => ({
    method: "POST",
    url: `${assets}/${id}/attach`,
  }),
  detach: (id: number): Endpoint => ({
    method: "POST",
    url: `${assets}/${id}/detach`,
  }),
  uploadRegister: {
    method: "POST",
    url: `${assets}/uploads/register`,
  } as Endpoint,
  uploadStart: `${assets}/uploads/start`,
  uploadChunk: `${assets}/uploads/chunk`,
  uploadComplete: `${assets}/uploads/complete`,
  workspaceStorageDetailed: (workspaceId: number): string =>
    `${assets}/storage/workspace/${workspaceId}/detailed`,
} as const;
